import React from "react";
import {
  grbsFormItems,
  vitalFormItems,
} from "./VitalGrbsMonitoring/vitalGrbsCols";
import { Form, Col, Row, InputNumber, TimePicker, Input } from "antd";
import { vitalValidations } from "../../../../helpers/medicineKeys";
const format = "hh:mm A";
const AiAddForm = ({ type }) => {
  const commonFormItems = type === "vitals" ? vitalFormItems : grbsFormItems;
  return (
    <>
      <Form.Item
        label="Time"
        name="action_time"
        rules={[{ required: true, message: "Please Select time" }]}
      >
        <TimePicker
          inputReadOnly
          format={format}
          needConfirm={false}
          style={{ width: "100%" }}
        />
      </Form.Item>
      <Row gutter={[12, 0]} className="nurse-monitoring-form-grid">
        {commonFormItems?.map((item) => (
          <Col xs={24} sm={12} key={item.value}>
            <Form.Item label={item?.name} name={item?.value}>
              {item?.value === "remarks" ? (
                <Input.TextArea />
              ) : item?.value === "insulin" ? (
                <InputNumber style={{ width: "100%" }} />
              ) : (
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder={`${vitalValidations[item?.value]?.minimum}-${
                    vitalValidations[item?.value]?.maximum
                  }`}
                />
              )}
            </Form.Item>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default AiAddForm;
